/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 会員種別
 * @export
 * @enum {number}
 */
export enum MemberTypeEnum {
    /** プレミアム会員 */
    PREMIUM_MEMBER = 1,
    /** 一般会員 */
    REGULAR_MEMBER = 2
}

/**
 * 会員種別 の Union 型
 * @export
 * @typedef MemberType
 */
export type MemberType =
  typeof MemberTypeEnum[keyof typeof MemberTypeEnum];

/**
 * 会員種別 のラベルマップ
 * @export
 */
export const MemberTypeLabels = {
    /**
     * 数値キー: MemberTypeEnum.PREMIUM_MEMBER
     * 名前キー:  PREMIUM_MEMBER
     */
    [MemberTypeEnum.PREMIUM_MEMBER]: 'プレミアム会員',
    PREMIUM_MEMBER:                             'プレミアム会員',
    /**
     * 数値キー: MemberTypeEnum.REGULAR_MEMBER
     * 名前キー:  REGULAR_MEMBER
     */
    [MemberTypeEnum.REGULAR_MEMBER]: '一般会員',
    REGULAR_MEMBER:                             '一般会員',
} as const;

/**
 * 会員種別 のラベル Union 型
 * @export
 * @typedef MemberTypeLabel
 */
export type MemberTypeLabel =
  typeof MemberTypeLabels[keyof typeof MemberTypeLabels];

/**
 * 会員種別 のラベル取得関数
 * @export
 * @param { MemberType } value - 列挙体の値
 * @returns { MemberTypeLabel } ラベル文字列
 */
export function getMemberTypeLabel(
  value: MemberType
): MemberTypeLabel {
  return MemberTypeLabels[value];
}

/**
 * 会員種別 のラベル配列を取得する関数
 * @export
 * @param { MemberType[] } values - 列挙体の値配列
 * @returns { MemberTypeLabel[] } ラベル文字列配列
 */
export function getMemberTypeLabels(values: MemberType[]): MemberTypeLabel[] {
  return values.map((value) => getMemberTypeLabel(value));
}

/**
 * 会員種別 のラベル配列
 * @export
 */
export const MemberTypeLabelList = [
  'プレミアム会員','一般会員',
] as const;

